


























































import {ActivityHistory} from '@/models';
import {Actions} from '@/store';
import {ToastsService, buildGeekName} from '@/utils';
import Vue from 'vue';

export default Vue.extend({
  name: 'DeleteActivityModal',
  props: {
    activity: Object as () => ActivityHistory,
  },
  data() {
    return {
      loader: {
        isRequestPending: false,
      },
      form: {
        id: '',
        name: '',
        activityName: '',
        subTypeName: '',
        date: null as unknown as Date,
      },
    };
  },
  methods: {
    async deleteGeeksActivity(): Promise<void> {
      try {
        await this.$store.dispatch(Actions.activities.deleteGeeksActivity, this.form.id);
        ToastsService.success(this.$t('admin-panel.activities.tabs.history.activity-deleted-toast') as string);
        this.$bvModal.hide('delete-activity-modal');
        this.$emit('refresh');
      } finally {
        this.loader.isRequestPending = false;
      }
    },
    async setActivity() {
      this.form = {
        id: this.activity.id,
        name: buildGeekName(this.activity.geek),
        activityName: this.activity?.type.name,
        subTypeName: this.activity?.subtype?.name ?? '',
        date: this.activity.createdAt,
      };
    },
  },
});
